import HSuiteApiService from '@/core/services/hsuiteApi.service'

async function GetAllIntegrations() {
    let result = null;
    await HSuiteApiService.get('/api/Integration/GetAllIntegrations').then(response => {
      result = response.data;
    })
    .catch(ex => {
      console.log(ex);
    })
  
    return result;
}

async function GetAllPlatformIntegrations() {
  let result = null;
  await HSuiteApiService.get('/api/Integration/GetAllPlatformIntegrations').then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}

async function GetQwilrIntegrationInfo() {
  let result = null;
  await HSuiteApiService.get('/api/Integration/GetIntegrationAuthorizationByProviderName/Qwilr').then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}

async function SignOutIntegration(payLoad) {
    let result = null;
    await HSuiteApiService.post(`/api/Integration/SignOutIntegration`, payLoad).then(response => {
      result = response;
    })
    .catch(ex => {
      console.log(ex);
      throw ex;
    })
  
    return result;
}

async function GetMetadataForClient(integrationProviderName) {
  let result = null;
  await HSuiteApiService.get('/api/Integration/GetMetadataForClient',`${integrationProviderName}`).then(response => {
    result = response.data;
  })
  .catch(ex => {
    console.log(ex);
  })

  return result;
}  

export { 
    GetAllIntegrations,
    SignOutIntegration,
    GetMetadataForClient,
    GetAllPlatformIntegrations,
    GetQwilrIntegrationInfo
}
